import { isUUIDV4, Queries } from '@aline/common';
import type { Core } from '@pdftron/webviewer';

export function getIsAlineAnnotation(widget: Core.Annotations.WidgetAnnotation): boolean {
  const name = widget.fieldName;
  if (isUUIDV4(name)) return true;
  return Queries.isCheckboxOptionCompositeFieldName(name);
}
